module.exports = __webpack_public_path__ + "static/media/LogoVitalbookBig.7799b019.svg";